module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeWindow),
      expression: "closeWindow"
    }],
    staticClass: "relative radius-large"
  }, [_c('button', {
    staticClass: "btn wide mr-3",
    on: {
      "click": _vm.toggleWindow
    }
  }, [_c('i', {
    staticClass: "ico-add large"
  }), _vm._v("\n        New Agent\n    ")]), _vm._v(" "), (_vm.showWindow) ? _c('div', {
    staticClass: "floating-menu shaded"
  }, [_c('h5', [_vm._v("Search for agents")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.email),
      expression: "form.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-100 fs-small",
    attrs: {
      "type": "email",
      "placeholder": "e.g. guide@pluralo.com"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value.trim())
      }, _vm.searchInputChanged],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dark fs-small normal"
  }, [(_vm.form.email.length > 0) ? _c('div', [(_vm.filteredAgents.length > 0) ? _c('div', {
    staticClass: "agentList"
  }, [_c('div', {
    staticClass: "darker my-3 font-weight-600"
  }, [_vm._v("Select to Add")]), _vm._v(" "), _vm._l((_vm.filteredAgents), function(agent) {
    return _c('div', {
      staticClass: "row w-100 mx-0 mb-2 justify-content-between mt-1"
    }, [(agent.image && agent.image != '') ? _c('div', {
      staticClass: "d-flex w-25"
    }, [_c('div', {
      staticClass: "bg-medium h-100 w-100 radius-normal imageCoverCenter",
      style: ({
        'background': 'url(' + agent.image + ')'
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "w-50 pointer",
      on: {
        "click": function($event) {
          return _vm.openAgentInfo(agent)
        }
      }
    }, [_c('div', {
      staticClass: "darkest hoverLink"
    }, [_vm._v(_vm._s(agent.brandName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-smaller"
    }, [(agent.location) ? _c('span', [_vm._v(_vm._s(agent.location + ', '))]) : _vm._e(), _vm._v(" "), (agent.place && agent.country && agent.country.name) ? _c('span', [_vm._v(" , ")]) : _vm._e(), _vm._v(" "), (agent.country && agent.country.name) ? _c('span', [_vm._v(_vm._s(agent.country.name))]) : _vm._e()])]), _vm._v(" "), _c('div', [(agent.helperAlreadyAdded) ? _c('button', {
      staticClass: "btn tertiary opacity-50",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Added")]) : _c('div', [_c('button', {
      staticClass: "connectStatusButton btn text-capitalize",
      class: _vm.connectButtonClass(agent),
      attrs: {
        "disabled": agent.isConnecting && agent.isConnecting
      },
      on: {
        "click": function($event) {
          return _vm.connectToAgent2(agent)
        }
      }
    }, [_vm._v(_vm._s(agent.isConnecting && agent.isConnecting == true ? 'Connecting' : _vm.connectButtonLabel(agent)))])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "shaded",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.invite($event)
      }
    }
  }, [_c('input', {
    staticClass: "btn blue wide full mt-4",
    attrs: {
      "type": "submit",
      "value": "Create New"
    }
  })])])]) : _c('div', [_vm._v("\n                Search for a agent in Pluralo by name or email address, or enter an email address to invite someone new.\n            ")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-847d0754", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847d0754"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentInviteButton.vue
// module id = 1829
// module chunks = 0